module.exports = {
  title: 'Play Midnight 3.0',
  description: `
    Play Midnight is an Extension for Chrome that injects JavaScript and CSS 
    into the Google Music website in order to give users a way to create a custom look for Google Play Music. Play Midnight is retired now, since Google Music is no longer around.
  `,
  tags: ['Chrome Extension API', 'CSS', 'Design', 'React', 'Redux', 'Redux-Saga'],
  images: [
    require('./images/1.png'),
    require('./images/2.jpg'),
    require('./images/3.jpg'),
    require('./images/4.jpg'),
    require('./images/5.jpg'),
    require('./images/6.jpg'),
  ],
  url: 'https://play-midnight.web.app/',
};



// WEBPACK FOOTER //
// ./src/data/works/playmidnight/index.js